import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "tw-flex container" };
const _hoisted_2 = { class: "tw-mx-auto tw-max-w-screen-2xl tw-w-full lg:tw-pt-0 tw-pt-3 sm:tw-mt-0 tw-mt-5" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CasinoHeader = _resolveComponent("CasinoHeader");
    const _component_CasinoComponentForAll = _resolveComponent("CasinoComponentForAll");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CasinoHeader, {
                games: $props.games,
                isLoading: $props.isLoading
            }, null, 8, ["games", "isLoading"]),
            _createElementVNode("div", null, [
                _createVNode(_component_CasinoComponentForAll, {
                    isLoading: $props.isLoading,
                    selectedCategory: $props.selectedCategory,
                    games: $setup.filteredGames,
                    gameCategories: $props.gameCategories,
                    casinoSideBarCategories: $props.casinoSideBarCategories
                }, null, 8, ["isLoading", "selectedCategory", "games", "gameCategories", "casinoSideBarCategories"])
            ])
        ])
    ]));
}
